import httpClient from '@/api/http-client';

const endpoint = 'api/email-logs';

const emailLogsService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),
};

export default emailLogsService;
